"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.correspondencePayloadSchema = void 0;
var constants_1 = require("@hobt/constants");
var common_1 = require("../../common");
var constants_2 = require("../../constants");
exports.correspondencePayloadSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['correspondenceTypeCode', 'submitterUserID', 'submitterUserTypeCode'],
    properties: {
        adjudicationNoteCategoryCode: {
            type: ['number', 'null'],
            anyOf: [
                { enum: __spreadArrays(Object.values(constants_2.AdjudicationNoteCategoryInternal), [null]) },
                { enum: __spreadArrays(Object.values(constants_2.AdjudicationNoteCategoryExternal), [null]) },
            ],
            errorMessage: 'Should equate to a valid AdjudicationNoteCategoryCode Enum value',
        },
        attachments: {
            type: 'array',
            minItems: 1,
            maxItems: 20,
            items: common_1.attachmentSchema,
            errorMessage: 'Should be an array of Attachments with at least 1 attachment and maximum 20',
        },
        cancellationReasonCode: {
            type: 'string',
            enum: Object.values(constants_2.CancellationReason),
            errorMessage: 'Should equate to a valid CancellationReason Enum value',
        },
        commentTypeCode: {
            type: 'number',
            enum: Object.values(constants_2.CommentType),
            errorMessage: 'Should equate to a valid CommentTypeCode Enum value',
        },
        correspondenceTypeCode: {
            type: 'number',
            enum: Object.values(constants_2.CorrespondenceType),
            errorMessage: 'Should equate to a valid CorrespondenceTypeCode Enum value',
        },
        declineReasonCode: {
            type: 'number',
            enum: Object.values(constants_2.DeclineReason),
            errorMessage: 'Should equate to a valid DeclineReasonCode Enum value',
        },
        documentRequestCategoryCode: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                enum: Object.values(constants_2.ClaimDocumentType),
            },
            errorMessage: 'Should be an array and equate to a valid documentRequestCategoryCode Enum value',
        },
        languageCode: {
            type: 'number',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should equate to a valid LanguageCode Enum value',
        },
        propertyDeficiencyCategoryCode: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.PropertyDeficiencyCategoryCode), [null, NaN]),
            errorMessage: 'Should equate to a valid PropertyDeficiencyCategoryCode Enum value',
        },
        remarkText: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'Should be a string and have maximum of 1000 characters',
        },
        claimStatusOverrideTypeCode: {
            type: 'number',
            enum: Object.values(constants_2.ClaimStatusOverrideType),
            errorMessage: 'Should equate to a valid ClaimStatusOverrideTypeCode Enum value',
        },
        submitterUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        submitterUserTypeCode: {
            type: 'number',
            enum: Object.values(constants_1.UserType),
            errorMessage: 'Should equate to a valid SubmitterUserType Enum value',
        },
        templateText: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2000,
            errorMessage: 'Should be a string and have maximum of 2000 characters',
        },
    },
    allOf: [
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.InternalNote,
                    },
                },
            },
            then: {
                required: ['adjudicationNoteCategoryCode'],
                errorMessage: 'should have the required property - adjudicationNoteCategoryCode',
                properties: {
                    adjudicationNoteCategoryCode: {
                        type: 'number',
                        enum: Object.values(constants_2.AdjudicationNoteCategoryInternal),
                        errorMessage: 'Should equate to a valid adjudicationNoteCategoryCode Enum value',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.Attachment,
                    },
                },
            },
            then: {
                required: ['attachments'],
                errorMessage: 'should have the required property - attachments',
                properties: {
                    attachments: {
                        type: 'array',
                        minItems: 1,
                        maxItems: 20,
                        items: common_1.attachmentSchema,
                        errorMessage: 'Should be an array of Attachments with at least 1 attachment and maximum 20',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.Attachment,
                    },
                },
            },
            then: {
                required: ['adjudicationNoteCategoryCode'],
                errorMessage: 'should have the required property - adjudicationNoteCategoryCode',
                properties: {
                    adjudicationNoteCategoryCode: {
                        type: 'number',
                        anyOf: [
                            { enum: __spreadArrays(Object.values(constants_2.AdjudicationNoteCategoryInternal), [null]) },
                            { enum: __spreadArrays(Object.values(constants_2.AdjudicationNoteCategoryExternal), [null]) },
                        ],
                        errorMessage: 'Should equate to a valid adjudicationNoteCategoryCode Enum value',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.Comment,
                    },
                },
            },
            then: {
                required: ['remarkText'],
                errorMessage: 'should have the required property - remarkText',
                properties: {
                    remarkText: {
                        type: ['string', 'null'],
                        minLength: 0,
                        maxLength: 1000,
                        errorMessage: 'Should be a string and have maximum of 1000 characters',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.ContestDecision,
                    },
                },
            },
            then: {
                if: {
                    properties: {
                        correspondenceTypeCode: {
                            const: constants_2.CorrespondenceType.External,
                        },
                    },
                },
                then: {
                    required: ['remarkText'],
                    errorMessage: 'should have the required property - remarkText',
                    properties: {
                        remarkText: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 1000,
                            errorMessage: 'Should have maximum of 1000 characters',
                        },
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.InternalNote,
                    },
                },
            },
            then: {
                if: {
                    properties: {
                        correspondenceTypeCode: {
                            const: constants_2.CorrespondenceType.Internal,
                        },
                    },
                },
                then: {
                    required: ['adjudicationNoteCategoryCode', 'remarkText'],
                    if: {
                        required: ['adjudicationNoteCategoryCode'],
                        properties: {
                            adjudicationNoteCategoryCode: {
                                const: constants_2.AdjudicationNoteCategoryInternal.ClaimStatusOverride,
                            },
                        },
                    },
                    then: {
                        required: ['claimStatusOverrideTypeCode'],
                        errorMessage: 'should have the required property - claimStatusOverrideTypeCode',
                        properties: {
                            claimStatusOverrideTypeCode: {
                                type: 'number',
                                enum: Object.values(constants_2.ClaimStatusOverrideType),
                                errorMessage: 'Should equate to a valid ClaimStatusOverrideTypeCode Enum value',
                            },
                        },
                        if: {
                            properties: {
                                claimStatusOverrideTypeCode: {
                                    const: constants_2.ClaimStatusOverrideType.Other,
                                },
                            },
                        },
                        then: {
                            required: ['remarkText'],
                            errorMessage: 'should have the required property - remarkText',
                            properties: {
                                remarkText: {
                                    type: 'string',
                                    minLength: 1,
                                    maxLength: 1000,
                                    errorMessage: 'Should have maximum of 1000 characters',
                                },
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.Decline,
                    },
                },
            },
            then: {
                if: {
                    properties: {
                        correspondenceTypeCode: {
                            const: constants_2.CorrespondenceType.External,
                        },
                    },
                },
                then: {
                    required: ['declineReasonCode'],
                    errorMessage: 'should have the required property - declineReasonCode',
                    properties: {
                        declineReasonCode: {
                            type: 'number',
                            enum: Object.values(constants_2.DeclineReason),
                            errorMessage: 'Should equate to a valid DeclineReasonCode Enum value',
                        },
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.Cancel,
                    },
                },
                required: ['commentTypeCode'],
            },
            then: {
                required: ['cancellationReasonCode'],
                errorMessage: 'should have the required property - cancellationReasonCode',
            },
            else: {
                properties: {
                    cancellationReasonCode: {
                        enum: [null, ''],
                        errorMessage: 'should have the property - cancellationReasonCode only when comment type code is cancel',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    commentTypeCode: {
                        const: constants_2.CommentType.DocumentationRequestNote,
                    },
                },
            },
            then: {
                required: ['documentRequestCategoryCode'],
                errorMessage: 'should have the required property - documentRequestCategoryCode',
                properties: {
                    documentRequestCategoryCode: {
                        type: 'array',
                        items: {
                            type: 'string',
                            enum: Object.values(constants_2.ClaimDocumentType),
                        },
                        minItems: 1,
                        uniqueItems: true,
                        errorMessage: 'Should be an array and equate to a valid documentRequestCategoryCode Enum value',
                    },
                },
            },
        },
    ],
};
